
export var hasBufferFrom = (typeof Buffer === 'function' && Buffer.from);